import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = { class: "col-12" };
const _hoisted_3 = { class: "carousel__item" };
const _hoisted_4 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Slide = _resolveComponent("Slide");
    const _component_Pagination = _resolveComponent("Pagination");
    const _component_Navigation = _resolveComponent("Navigation");
    const _component_Carousel = _resolveComponent("Carousel");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Carousel, {
                autoplay: 4000,
                "wrap-around": true
            }, {
                addons: _withCtx(() => [
                    _createVNode(_component_Pagination),
                    (!_ctx.isMobile)
                        ? (_openBlock(), _createBlock(_component_Navigation, { key: 0 }, {
                            next: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                    _createElementVNode("div", { class: "sliderButtonBox" }, [
                                        _createElementVNode("i", { class: "icon-arrow-next fc-brand_deep_blue font3" })
                                    ], -1)
                                ]))]),
                            prev: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                    _createElementVNode("div", { class: "sliderButtonBox" }, [
                                        _createElementVNode("i", { class: "icon-arrow-prev fc-brand_deep_blue font3" })
                                    ], -1)
                                ]))]),
                            _: 1
                        }))
                        : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide, index) => {
                        return (_openBlock(), _createBlock(_component_Slide, { key: index }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("div", { innerHTML: slide }, null, 8, _hoisted_4)
                                ])
                            ]),
                            _: 2
                        }, 1024));
                    }), 128))
                ]),
                _: 1
            })
        ])
    ]));
}
